/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Kanban_Db_Ref_ErrorInputs */



/**
* | output |
* | --- |
* | "Database reference not available" |
*
* @param {Explorer_Kanban_Db_Ref_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_kanban_db_ref_error = /** @type {((inputs?: Explorer_Kanban_Db_Ref_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Kanban_Db_Ref_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Reference de base de donnees non disponible")
	if (locale === "de") return /** @type {LocalizedString} */ ("Datenbankreferenz nicht verfügbar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Riferimento al database non disponibile")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ссылка на базу данных недоступна.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Referencia de base de datos no disponible")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("数据库引用不可用")
	if (locale === "ja") return /** @type {LocalizedString} */ ("データベース参照が利用できません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("डेटाबेस संदर्भ उपलब्ध नहीं है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Referência de banco de dados não disponível")
	return /** @type {LocalizedString} */ ("Database reference not available")
});